import { useEffect } from "react";

const PaymentSuccessModal = ({ open, onClose }) => {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-lg p-6 text-center">

        {/* Animated Tick */}
        <div className="mx-auto mb-4 w-20 h-20 rounded-full border-4 border-green-500 flex items-center justify-center animate-scaleIn">
          <svg
            className="w-10 h-10 text-green-500 animate-drawTick"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* Message */}
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Payment Submitted
        </h2>

        <p className="text-sm text-gray-600">
          Payments are verified manually. Credit processing may take up to 5–10 minutes. Please allow some time for your coins to be deposited. If the delay persists, kindly contact our support team for assistance.
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="mt-5 w-full bg-green-600 text-white py-2.5 rounded-xl font-semibold"
        >
          OK
        </button>

      </div>
    </div>
  );
};

export default PaymentSuccessModal;